/* Filtros, orden, paginación y vista de la cuadrícula con Section Rendering API (vanilla). */
(() => {
  const root = document.querySelector('[data-facets-root]');
  if (!root) return;
  const sectionId = root.dataset.section;
  const KEY = 'yo-grid-view';

  const applyView = () => {
    let v = 'large'; try { v = localStorage.getItem(KEY) || 'large'; } catch (e) {}
    root.querySelectorAll('[data-grid-view]').forEach((g) => { g.dataset.view = v; });
    root.querySelectorAll('.fct__vbtn').forEach((b) => b.setAttribute('aria-pressed', b.dataset.grid === v ? 'true' : 'false'));
  };

  const render = async (url, push = true) => {
    const openId = (root.querySelector('details[open]') || {}).id;
    root.classList.add('is-loading');
    try {
      const u = new URL(url, window.location.origin);
      u.searchParams.set('section_id', sectionId);
      const res = await fetch(u.toString());
      if (!res.ok) throw new Error(res.status);
      const doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      const fresh = doc.querySelector('[data-facets-root]');
      if (!fresh) throw new Error('no section');
      root.innerHTML = fresh.innerHTML;
      if (openId) { const d = document.getElementById(openId); if (d) { d.open = true; const s = d.querySelector('summary'); if (s && document.activeElement === document.body) s.focus(); } }
      applyView();
      if (push) { u.searchParams.delete('section_id'); history.pushState({ facets: true }, '', u.pathname + (u.search ? u.search : '')); }
    } catch (e) {
      window.location.href = url;
    } finally { root.classList.remove('is-loading'); }
  };

  const formUrl = (form) => {
    const fd = new FormData(form); const p = new URLSearchParams();
    fd.forEach((v, k) => { if (v !== '' && !(k === 'sort_by' && v === form.dataset.defaultSort)) p.append(k, v); });
    return `${window.location.pathname}?${p.toString()}`;
  };

  root.addEventListener('change', (e) => {
    const form = e.target.closest('[data-facets-form]'); if (!form) return;
    if (e.target.type === 'number') return;
    render(formUrl(form));
  });
  root.addEventListener('submit', (e) => {
    const form = e.target.closest('[data-facets-form]'); if (!form) return;
    e.preventDefault(); render(formUrl(form));
  });
  root.addEventListener('click', (e) => {
    const a = e.target.closest('[data-facet-link]');
    if (a) { e.preventDefault(); render(a.href); if (a.closest('.pag')) root.scrollIntoView({ behavior: 'smooth', block: 'start' }); return; }
    const v = e.target.closest('.fct__vbtn');
    if (v) { try { localStorage.setItem(KEY, v.dataset.grid); } catch (err) {} applyView(); }
  });
  document.addEventListener('click', (e) => {
    if (!root.contains(e.target)) root.querySelectorAll('details[open]').forEach((d) => { d.open = false; });
  });
  root.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const d = e.target.closest('details[open]'); if (d) { d.open = false; d.querySelector('summary').focus(); }
  });
  window.addEventListener('popstate', () => render(window.location.href, false));
  applyView();
})();
